import { TemplateRef } from '@angular/core';

import { Observable } from 'rxjs';

export type SharedTableToggleCallback = (item: Record<string, unknown>, enabledColumnName: string) => void;

export interface SharedTableColumn {
  key: string;
  title: string;
  dataType: SharedTableItemType;
  cellTemplateRef?: TemplateRef<unknown>;
  headerTemplateRef?: TemplateRef<unknown>;
  isLink?: boolean;
  width?: number;
  linkAction?: (item: Record<string, unknown>) => void;
  toggleCallback?: SharedTableToggleCallback;
  isSortable?: boolean;
}

export interface SharedTableDataSource<T> {
  loadData(params: Record<string, unknown>): Observable<T[]>;
  page: number;
  pageSize: number;
  maxDisplayPages: number;
  total: number;
}

export enum SharedTableItemType {
  string = 'string',
  number = 'number',
  date = 'date',
  toggle = 'toggle',
  custom = 'custom',
}
